import { EmployeeForm } from "@/components/EmployeeForm";
import { EmployeeTable } from "@/components/EmployeeTable";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import { useState } from "react";

export default function Employees() {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="p-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Employee Management</h1>
        <Button onClick={() => setShowForm(!showForm)}>
          <UserPlus className="mr-2" />
          {showForm ? "Close Form" : "New Employee"}
        </Button>
      </div>

      {showForm && (
        <div className="mb-8">
          <EmployeeForm />
        </div>
      )}

      <EmployeeTable />
    </div>
  );
}